export default __webpack_public_path__ + "static/media/vidoe-guide.8f0660aa.png";